import { call, put, takeLatest } from "redux-saga/effects";
import api from "../api";
import {
  REQUEST_TRANSLATIONS,
  requestTranslationsSuccess,
  requestTranslationsFailed
} from "../actions/translations";

export function* watchRequestTranslations() {
  yield takeLatest(REQUEST_TRANSLATIONS, fetchTranslations);
}

function* fetchTranslations(action) {
  try {
    const data = yield call(api.translations(action.locale));
    yield put(requestTranslationsSuccess(data));
  } catch (e) {
    yield put(requestTranslationsFailed(e));
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/translations.js